// src/components/Footer.js
import React from 'react';

function Footer() {
  return (
    <footer align="center">
      <p>&copy; 2025 Presidio </p>
      <p>Any questions reach out to Paul Bartholomai pbartholomai@presidio.com</p>
    </footer>
  );
}

export default Footer;